import {request} from '../services/request';
import {expenseConstants} from '../constants';
import {backendEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';

const errorHandlerProps = {disableAlert: true};

const {getUrl} = apiHelpers;

const getExpenses = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpense = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE, {id}),
      successCallback: (data) => {
        dispatch({
          type: expenseConstants.GET_EXPENSE,
          data
        });
        successCallback?.(data);
      },
      errorCallback
    });
  }
}

const getExpenseAttachment = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE_ATTACHMENT, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpenseRelatedInvoices = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE_RELATED_INVOICES, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const createExpense = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_CREATE,
      data,
      successCallback,
      errorCallback
    });
  }
}

const updateExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_UPDATE, {id}),
      data,
      successCallback,
      errorCallback
    });
  }
}

const approveExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_APPROVE, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reassignExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_REASSIGN, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reopenExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.patch({
      dispatch,
      url: getUrl(backendEndpoints.PATCH_EXPENSE_EDIT_REVIEW, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const rejectExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_REJECT, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const submitExpenseForReview = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.patch({
      dispatch,
      url: getUrl(backendEndpoints.PATCH_EXPENSE_SUBMIT_FOR_REVIEW, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const discardExpenseAutoApproval = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_DISCARD_AUTO_APPROVAL, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBatchExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSES_BATCH,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const downloadZipInvoices = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_ZIP_INVOICES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps,
    });
  }
}

const exportExpenses = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_EXPORT,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const deleteExpense = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.DELETE_EXPENSE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const recalculateExpensePolicyStatus = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.PUT_EXPENSE_POLICY_STATUS_RECALCULATE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const openAddExpenseModal = () => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.OPEN_ADD_EXPENSE_MODAL,
    });
  }
}

const closeAddExpenseModal = () => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.CLOSE_ADD_EXPENSE_MODAL,
    });
  }
}

export const expenseActions = {
  getExpenses,
  getExpense,
  getExpenseAttachment,
  getExpenseRelatedInvoices,
  getBatchExpenses,

  approveExpense,
  createExpense,
  deleteExpense,
  reassignExpense,
  rejectExpense,
  reopenExpense,
  submitExpenseForReview,
  discardExpenseAutoApproval,
  updateExpense,
  downloadZipInvoices,
  exportExpenses,
  recalculateExpensePolicyStatus,

  openAddExpenseModal,
  closeAddExpenseModal,
};
